export const YEARS_INDEX = {
  CURRENT: 0,
  PREVIOUS: 1,
};
